import CircularProgress from "@mui/material/CircularProgress";

import styles from "./ButtonBase.css";

const MUI_ONLY_PROPS = [
  "variant",
  "color",
  "disableElevation",
  "disableFocusRipple",
  "disableRipple",
  "fullWidth",
  "size",
  "startIcon",
  "endIcon",
  "component",
];

function stripMuiProps(rest) {
  const next = { ...rest };
  MUI_ONLY_PROPS.forEach((key) => {
    delete next[key];
  });
  return next;
}

const ButtonBase = (props) => {
  const {
    children,
    loading,
    className = "",
    disabled,
    href,
    type = "button",
    ...rest
  } = props;

  const classes = styles();
  const isDisabled = disabled || loading;
  const domProps = stripMuiProps(rest);
  const mergedClassName = `${classes.button} ${className}`.trim();

  const progress = loading ? (
    <CircularProgress size={24} className={classes.buttonProgress} />
  ) : null;

  if (href) {
    const { onClick, ...anchorRest } = domProps;
    return (
      <div className={classes.wrapper}>
        <a
          href={href}
          className={mergedClassName}
          aria-disabled={isDisabled || undefined}
          aria-busy={loading || undefined}
          tabIndex={isDisabled ? -1 : undefined}
          onClick={(e) => {
            if (isDisabled) {
              e.preventDefault();
              return;
            }
            if (onClick) {
              onClick(e);
            }
          }}
          {...anchorRest}
        >
          <span className={loading ? classes.buttonLabelHidden : undefined}>
            {children}
          </span>
        </a>
        {progress}
      </div>
    );
  }

  return (
    <div className={classes.wrapper}>
      <button
        type={type}
        className={mergedClassName}
        disabled={isDisabled}
        aria-busy={loading || undefined}
        {...domProps}
      >
        <span className={loading ? classes.buttonLabelHidden : undefined}>
          {children}
        </span>
      </button>
      {progress}
    </div>
  );
};

export default ButtonBase;
